export default "__VITE_ASSET__DLqGnAZD__"